import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupName } from '@angular/forms';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent {
  @Input() title: string;
  @Input() name: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() readonly: boolean;
  @Input() type: string;
  @Input() mask: string;
  @Input() length: number;
  @Input() placeholder: string = '';
  @Input() value: string = '';
  @Input() justNumbers: boolean;
  // PROD-3366: quando false, desliga a validacao de mascara do ngx-mask.
  // A mascara continua formatando/limitando, mas um valor incompleto
  // (ex.: "0" com mask="0000") deixa de invalidar o campo.
  @Input() maskValidation: boolean = true;

  constructor() {}

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

  numberOnly(event): boolean {
    if(this.justNumbers){
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }else{
      return true
    }

  }
}
